import { useRef, useMemo } from 'react';
import { Card, Stack } from '@mui/material';
import { usePageView } from 'src/hooks/use-page-view';
import { useSelection } from 'src/hooks/use-selection';
import ListSearch from 'src/components/ui/search/list-search';
import { ListTable } from './list-table';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import { appStr } from 'src/locales/app_strings';
import { useRouter } from 'src/hooks/use-router';
import { nextNavigate } from 'src/utils/navigation-utils';
import { paths } from 'src/paths';
import TitleButton from 'src/components/ui/headers/title-button';
import PageSection from 'src/layouts/page-section';

const Page = ({ dataSearch, dataStore, dataIds }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const router = useRouter();
  const dataSelection = useSelection(dataIds);

  usePageView();

  const labels = useMemo(
    () => ({
      sub: { short: 'name', full: "Tên khóa" },
      both: { short: 'code', full: "Mã khóa" },
    }),
    [t]
  );
  
  const handleDetail = (item) => {
    const params = item ? { id: item.id } : {};
    nextNavigate(
      router,
      dataSearch.state,
      paths.courses.details,
      paths.courses.index,
      params,
    );
  };

  return (
    <PageSection title="Courses" rootRef={rootRef}>
      <Stack spacing={1}>
        <TitleButton label={t(tokens.nav.course)} onButtonClick={handleDetail} />
        <Card>
          <ListSearch
            onFiltersChange={dataSearch.handleFiltersChange}
            filtersQuery={dataSearch.state.filters.query}
            placeholder={'sub'}
            filterLabels={labels}
          />
          <ListTable
            dataStore={dataStore}
            onDeselectAll={dataSelection.handleDeselectAll}
            onDeselectOne={dataSelection.handleDeselectOne}
            onPageChange={dataSearch.handlePageChange}
            onRowsPerPageChange={dataSearch.handleRowsPerPageChange}
            onSelectAll={dataSelection.handleSelectAll}
            onSelectOne={dataSelection.handleSelectOne}
            page={dataSearch.state.page}
            rowsPerPage={dataSearch.state.rowsPerPage}
            selected={dataSelection.selected}
            onNavigate={dataSearch.handleNavigateChange}
            onDetailClicked={handleDetail}
          />
        </Card>
      </Stack>
    </PageSection>
  );
};

export default Page;
